import { HttpClient } from '@angular/common/http';
import {
    AfterViewInit,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
} from "@angular/core";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { helper } from "src/environments/helper";
import { MatCalendar } from "@angular/material/datepicker";
import { PopoverDirective } from "ngx-bootstrap/popover";

@Component({
    selector: "app-toate-tabel-borderou",
    templateUrl: "./toate-tabel-borderou.component.html",
    styleUrls: ["./toate-tabel-borderou.component.scss"],
})
export class ToateTabelBorderouComponent
    implements OnInit, OnDestroy, AfterViewInit {
    @Input() data!: any;
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    // Popover dates
    @ViewChild("startCalendar") startCalendar!: MatCalendar<Date>;
    @ViewChild("endCalendar") endCalendar!: MatCalendar<Date>;
    @ViewChild(PopoverDirective) popover!: PopoverDirective;
    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date(new Date().getFullYear(), 0, 1);
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = "current_year";

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;
    isLoading = false;
    // borderou_id!: number;
    // borderou_slug!: string;
    dtLink =
        environment.interop.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderou
            .borderouList;

    constructor(private http: HttpClient) { }

    ngAfterViewInit(): void {
        this.dtTrigger.next("");
    }
    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }
    ngOnInit(): void {
        // this.borderouService.currentBorderouId$.subscribe({
        //   next: (bordeoru_id) => {
        //     console.log(bordeoru_id.borderouId);
        //     this.borderou_id = bordeoru_id.borderouId;
        //   },
        //   error: (error) => {},
        //   complete: () => {},
        // });
        // this.borderouService.currentBorderouSlug$.subscribe({
        //   next: (bordeoru_slug) => {
        //     console.log(bordeoru_slug.borderouSlug);
        //     this.borderou_slug = bordeoru_slug.borderouSlug;
        //   },
        //   error: (error) => {},
        //   complete: () => {},
        // });
        this.renderDT();
    }

    dateFilterOption: number = 1;
    dateFilter: any;
    date_from: any;
    date_to: any;

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);
        this.rerenderDT();
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }
    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }
    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.rerenderDT();
        this.selectedFilteringButton =
            yearsBack === 0 ? "current_year" : "previous_year";
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [year, month, day].join("-");
    }
    onDateFilterChange(): void {
        this.rerenderDT();
    }

    // Methods used to dinamically select the start date according to the end date

    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    renderDT() {
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 25,
            order: [[0, "desc"]],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                dataTablesParameters.date_from = this.formatDate(this.selectedStartDate);
                dataTablesParameters.date_to = this.formatDate(this.selectedEndDate);

                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columnDefs: [
                { width: "50px", targets: 0 },
                { width: "100px", targets: 1 },
            ],

            columns: [
                {
                    title: "Nr crt",
                    data: "id",
                    sortable: false,
                },
                {
                    title: "Nr/Data Cerere",
                    data: null,
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `
							<div style="display: flex; align-items: center; gap: 5px; width:200px">
                            <span style="padding: 2px 4px; background-color: #bdbdbd; border: 0px;border-radius:10px">${row.cerere_details ? row.cerere_details : "N/A"}</span>
							</div>
						`;
                    },
                },
                {
                    title: "Denumire Societate",
                    data: "f_denumire_institutie",
                    sortable: false,
                },
                {
                    title: "Adresa Sediu",
                    data: "sediu",
                    sortable: false,
                },
                {
                    title: "Adresa Punct lucru",
                    data: "punct_lucru",
                    sortable: false,
                },

                {
                    title: "CAEN",
                    data: "f_cod_caen",
                    sortable: false,
                },
                {
                    title: "Nr Acord",
                    data: "acord_numar",
                    sortable: false,
                },
                {
                    title: "Motiv respingere",
                    data: "anulat_observatii",
                    sortable: false,
                },
            ],
        };
    }

    rerenderDT(paginate = false): void {
        this.isLoading = true;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.isLoading = false;
            dtInstance.draw(paginate);
        });
    }
}
